import { useEffect, useState } from 'react';
import './employmentdata.css'
export default function Employmentdata() {
    const [applications, setApplications] = useState([]);

    useEffect(() => {
      fetch("http://185.164.73.170:5000/applications")
        .then((res) => {
          if (!res.ok) {
            throw new Error('Network response was not ok');
          }
          return res.json();
        })
        .then((data) => setApplications(data))
        .catch((error) => console.error("Error fetching applications:", error));
    }, []);
  
    const handleStatusChange = async (id, status) => {
      try {
        const response = await fetch(`http://185.164.73.170:5000/applications/${id}/status`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ status }),
        });
        if (response.ok) {
          setApplications((prev) =>
            prev.map((app) => (app.id === id ? { ...app, status } : app))
          );
        } else {
          alert("Failed to update status");
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };
    const handleDelete = async (id) => {
        try {
          const response = await fetch(`http://185.164.73.170:5000/applications/${id}`, {
            method: "DELETE",
          });
          if (response.ok) {
            setApplications((prev) => prev.filter((app) => app.id !== id));
          } else {
            alert("Failed to delete application");
          }
        } catch (error) {
          console.error("Error deleting application:", error);
        }
      };
    return (
      <div className="container">
  <div class="table-wrapper">
        <h2>فرم های استخدام</h2>
        <table border="1">
          <thead>
            <tr>
              <th>کد</th>
              <th>نام</th>
              <th>نام خانوادگی</th>
              <th>تاریخ تولد</th>
              <th>مهارت</th>
              <th>آدرس</th>
              <th>شماره تلفن</th>
              <th>ایمیل</th>
              <th>آخرین مدرک تحصیلی</th>
              <th>رشته تحصیلی</th>
              <th>سابقه کار</th>
              <th>حقوق درخواستی</th>
              <th>وضعیت</th>
              <th>تغییر وضعیت</th>
            </tr>
          </thead>
          <tbody>
            {applications.map((app) => (
              <tr key={app.id}>
                <td>{app.codenumber}</td>
                <td>{app.firstName}</td>
                <td>{app.lastName}</td>
                <td>{app.birthDate}</td>
                <td>{app.skills}</td>
                <td>{app.address}</td>
                <td>{app.phone}</td>
                <td>{app.email}</td>
                <td>{app.educationLevel}</td>
                <td>{app.major}</td>
                <td>{app.experience}</td>
                <td>{app.money}</td>
                <td>{app.status}</td>
                <td>
                  <button className='status-accepted' onClick={() => handleStatusChange(app.id, "accepted")}>قبول</button>
                  <button className='status-rejected' onClick={() => handleStatusChange(app.id, "rejected")}>رد</button>
                <button className='delete-btn' onClick={() => handleDelete(app.id)}>حذف</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
        </div>
    )
}